<template>
  <div class="view-register">
    <h2 class="animate-right text-semibold mb-6">
      Criar uma conta
    </h2>

    <form v-show="step == 1" @submit.prevent="next">
      <div class="d-flex flex-column gap-4">
        <snow-input
          v-model="form.name"
          id="name"
          label="Nome completo"
          type="text"
          @setError="setError"
        />

        <snow-input
          v-model="form.email"
          id="email"
          type="email"
          label="E-mail"
          :rules="rules.email"
        />

        <snow-input
          v-model="form.password"
          id="password"
          type="password"
          label="Senha"
          :rules="rules.password"
        />

        <snow-input
          v-model="form.confirm_password"
          id="confirm_password"
          type="password"
          label="Confirmar senha"
          :rules="rules.confirm_password"
        />
        <auth-button text="Próximo" class="mt-3" :loading="loading" />
      </div>
    </form>
    <form v-show="step == 2" @submit.prevent="submit">
      <snow-input
        v-model="form.phone"
        id="phone"
        class="mb-4"
        type="tel"
        label="Número de WhatsApp"
        mask="(##) #####-####"
      />
      <snow-input
        v-model="form.instagram"
        class="mb-4"
        id="instagram"
        label="Instagram"
      />
      <div class="d-flex">
        <snow-checkbox id="terms" isBoolean v-model="terms" :value="true" />
        <p>
          Declaro que concordo com os
          <a :href="`${paymentBaseUrl}/termos-de-uso`" target="_blank">
            Termos de uso </a
          >, estou ciente da
          <a
            :href="`${paymentBaseUrl}/politica-de-privacidade`"
            target="_blank"
          >
            Política de privacidade
          </a>
          da {{ $config.get("title") }} e sou maior de idade de acordo com a
          legislação aplicável.
        </p>
      </div>
      <auth-button
        text="Concluir"
        :loading="loading"
        :disabled="!terms || loading"
      />
    </form>
    <p class="text-center mt-6">
      Já tem um conta?
      <router-link class="main" :to="{ name: 'login' }">
        Fazer login
      </router-link>
    </p>

    <!-- <div class="footer fs-14">

      Este site é protegido por reCAPTCHA e a
      <a target="_blank" href="https://policies.google.com/privacy">
        Política de Privacidade
      </a>
      e os
      <a target="_blank" href="https://policies.google.com/terms">
        Termos de Serviço
      </a>
      do Google se aplicam.
    </div> -->
  </div>
</template>

<script>
import AuthButton from "@/components/auth/AuthButton.vue";
import { formFields } from "@/functions/helpers.js";

export default {
  components: { AuthButton },
  computed: {
    paymentBaseUrl() {
      return (
        process.env.VUE_APP_API_BASE_URL_PAY || "https://pay.zeuspay.com.br"
      );
    }
  },
  data() {
    return {
      ...formFields([
        "name",
        "email",
        "password",
        "confirm_password",
        "phone",
        "segment",
        "instagram"
      ]),
      terms: false,
      loading: false,
      ddi: 55,
      step: 1,
      rules: {
        email: [
          v => !!v || "O e-mail é obrigatório",
          v => /.+@.+\..+/.test(v) || "E-mail deve ser válido"
        ],
        password: [
          v => !!v || "A senha é obrigatória",
          v =>
            (v && v.length >= 6) || "A senha deve conter no mínimo 6 caracteres"
        ],
        confirm_password: [
          v => !!v || "A confirmação de senha é obrigatória",
          v =>
            v === this.form.password ||
            "A senha de confirmação deve ser igual a senha"
        ]
      }
    };
  },
  methods: {
    // phoneCountryChanged(obj) {
    //   this.ddi = obj.dialCode;
    // },
    setError(error, field) {
      this.errors[field] = error;
    },
    login() {
      this.$router.push({ name: "login" });
    },
    next() {
      this.step = 2;
    },
    submit() {
      this.$message.hide();
      this.loading = true;

      grecaptcha.enterprise.ready(async () => {
        try {
          const token = await grecaptcha.enterprise.execute(
            window.RECAPTCHA_ENTERPRISE_SITE_KEY,
            { action: "SIGNUP" }
          );
          this._submit(token);
        } catch {
          this.loading = false;
          this.$message.error("Por favor, tente novamente");
        }
      });
    },
    _submit(recaptcha_token) {
      const data = { ...this.form, recaptcha_token };
      if (data.phone) {
        data.phone = `${this.ddi}${data.phone}`;
      }
      data.segment = "sell";
      data.query_params = this.$route.query;

      if (this.form.password !== this.form.confirm_password) {
        this.errors.confirm_password = [
          "A senha de confirmação deve ser igual a senha"
        ];
        this.step = 1;
        this.loading = false;
        return;
      }

      this.$store
        .dispatch("user/register", data)
        .then(response => {
          this.$store.dispatch("postLogin").catch(() => {
            this.$router.replace({
              name: "login",
              query: { path: this.$route.fullPath }
            });
          });
          this.$router.push({ name: "home", params: { first_access: true } });
          this.$dataLayer.push({
            event: "generate-lead",
            name: response.name,
            email: response.email,
            phone: response.phone
          });
        })
        .catch(error => {
          this.errors = error.response.data;
          if (this.errors.non_field_errors) {
            this.$message.error(this.errors.non_field_errors[0]);
          } else if (this.errors.message) {
            this.$message.error(this.errors.message);
          }
          if (
            this.errors.name ||
            this.errors.email ||
            this.errors.password ||
            this.errors.confirm_password
          ) {
            this.step = 1;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-register {
  width: 100%;
  // ::v-deep {
  //   .custom-control-label::before {
  //     background: transparent !important;
  //     border: #adb5bd solid 1px !important;
  //     box-shadow: unset;
  //   }
  // }
  // .footer {
  //   margin-top: 20px;
  //   text-align: center;
  //   font-size: 16px;
  //   color: var(--semantic-neutral-600, #c7c7c7);
  //   a {
  //     color: #fff;
  //   }
  // }
}
</style>
